import { render, staticRenderFns } from "./PopupCreateOilManagement.vue?vue&type=template&id=a0f55762&scoped=true"
import script from "./PopupCreateOilManagement.vue?vue&type=script&lang=js"
export * from "./PopupCreateOilManagement.vue?vue&type=script&lang=js"
import style0 from "./PopupCreateOilManagement.vue?vue&type=style&index=0&id=a0f55762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f55762",
  null
  
)

export default component.exports